import React from "react";

const Overview = props => {

    return (
        <>
            Đây là dashboard
        </>
    );
};

Overview.propTypes = {};

export default Overview;
